import { useMemo } from "react";

import { useTiVoDeviceData } from "components/form/fields/TiVoTargets";

import { PublicationHistoryPanel, PublicationsTable } from "./components";
import { useTargets } from "./TargetsProvider";
import styles from "./TiVoPublicationsList.scss";
import { buildRenderPublicationSummary } from "./TiVoPublicationsSummaryTable";
import { PublicationsTableProps } from "./types";

export function TiVoPublicationsHistoryTable({
  platforms,
  publications,
  status,
}: PublicationsTableProps) {
  const deviceData = useTiVoDeviceData();
  const { targets, setTargets } = useTargets();

  const renderPublicationSummary = useMemo(
    () => buildRenderPublicationSummary(deviceData),
    [deviceData]
  );

  return (
    <PublicationsTable
      colClassName={styles.summaryCol}
      platforms={platforms}
      publications={publications}
      status={status}
      targets={targets}
      renderRowPanel={(props) => <PublicationHistoryPanel {...props} />}
      setTargets={setTargets}
    >
      {renderPublicationSummary}
    </PublicationsTable>
  );
}
